import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { api } from '../lib/api';
import { formatPrice } from '../lib/currency';
import { Wifi, Zap, ExternalLink, ArrowRight } from 'lucide-react';

// Shown on the flight results page once a destination fare is on screen: the cheapest eSIM
// for that country, so travellers arrive already connected. Live data only — renders nothing
// if no plan covers the destination.
export const EsimCrossSell = ({ countryCode, destinationCity, currency }) => {
  const [data, setData] = useState(undefined); // undefined=loading, null=none
  const navigate = useNavigate();

  useEffect(() => {
    if (!countryCode) { setData(null); return; }
    let alive = true;
    setData(undefined);
    api.esimCrossSell(countryCode)
      .then(({ data }) => { if (alive) setData(data.available ? data : null); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, [countryCode]);

  if (data === undefined || data === null) return null;
  const p = data.cheapest;
  const buy = () => {
    api.esimTrack('buy_clicked', { provider: p.provider, product_id: p.product_key, destination: countryCode, surface: 'flight_results', price: p.price_inr });
    window.open(api.esimBuyUrl(p.product_key), '_blank', 'noopener');
  };
  return (
    <Card className="rounded-2xl border-accent/30 bg-gradient-to-br from-accent/[0.07] to-transparent p-4 mb-4" data-testid="esim-cross-sell">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <Badge className="rounded-full bg-accent/15 text-accent mb-1.5"><Wifi className="h-3.5 w-3.5 mr-1" />Stay connected in {destinationCity || data.name}</Badge>
          <p className="text-sm font-medium">Skip roaming bills — get a {data.name} travel eSIM from{' '}
            <span className="font-semibold text-accent">{formatPrice(p.price_inr, currency)}</span></p>
          <p className="text-xs text-muted-foreground mt-0.5 flex items-center gap-2 flex-wrap">
            <span className="font-medium text-foreground">{p.data_amount}</span> · {p.validity_days} day{p.validity_days === 1 ? '' : 's'} · {p.network}
            {p.is_5g && <span className="inline-flex items-center gap-0.5"><Zap className="h-3 w-3" />5G</span>}
            · {data.count} plans available
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="outline" size="sm" className="rounded-xl" onClick={() => navigate(`/esim/${data.slug}`)} data-testid="esim-cross-sell-compare">
            Compare <ArrowRight className="h-3.5 w-3.5 ml-1" />
          </Button>
          <Button size="sm" className="rounded-xl bg-accent text-accent-foreground hover:bg-accent/90 font-semibold" onClick={buy} data-testid="esim-cross-sell-buy">
            Get eSIM <ExternalLink className="h-3.5 w-3.5 ml-1" />
          </Button>
        </div>
      </div>
    </Card>
  );
};
